// A short buzz on the moments that commit something.
//
// Motion has weight: a card that flies away should be felt, not just watched.
// Vibration is unsupported on iOS Safari and can be switched off by the person,
// so every call is best-effort and nothing may depend on it having happened.
//
// Kept deliberately small. Buzzing on every tap turns into noise a person
// disables, which then costs you the buzzes that mattered.

type Weight = "tick" | "commit" | "landing";

const PATTERNS: Record<Weight, number | number[]> = {
  tick: 8,        // passing a threshold, a card catching
  commit: 18,     // a choice that sticks
  landing: [14, 40, 22], // arrival: the champion beat, the season ending
};

export function buzz(weight: Weight = "commit") {
  try {
    if (typeof navigator === "undefined" || !("vibrate" in navigator)) return;
    // Someone who asked for less motion asked for less of this too.
    if (window.matchMedia?.("(prefers-reduced-motion: reduce)").matches) return;
    navigator.vibrate(PATTERNS[weight]);
  } catch {
    /* unsupported, blocked, or in a background tab. Never worth failing over. */
  }
}
